import { autoinject, LogManager, bindable } from 'aurelia-framework';
import { EntityController } from 'pages/entity/entity-controller';
import { ChildItemInfo } from 'data/entities/entities';
import { ChildItemInfoService } from 'data/service/child-item-info-service';
import { MetadataService } from 'data/service/meta-data-service';

@autoinject()
export class FolderGrid {

	@bindable folders: Array<ChildItemInfo>;
	
	logger = LogManager.getLogger('FolderGrid');

	moveFolderUp(childItemInfo:ChildItemInfo) {
		this.moveUpInGrid(childItemInfo);
		this.controller.moveUp(childItemInfo);
	}

	private moveUpInGrid(childItemInfo: ChildItemInfo) {
        let itemIndex = this.folders.findIndex(x => x.id === childItemInfo.id);
        this.folders._move(itemIndex, itemIndex - 1);
        
    }

	moveFolderDown(childItemInfo: ChildItemInfo) {
		this.moveDownInGrid(childItemInfo);
		this.controller.moveDown(childItemInfo);
	}

	constructor(private controller: EntityController,
		private childItemInfoService: ChildItemInfoService
	) {

		

	}

    private moveDownInGrid(childItemInfo: ChildItemInfo) {
        let itemIndex = this.folders.findIndex(x => x.id === childItemInfo.id);
        this.folders._move(itemIndex, itemIndex + 1);
	}

	
  }

